<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="16">
                &nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true" v-if="$isFullAdmin">{{$t('common.create')}}</el-button>
                <el-button icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="8">
                <el-input v-model="filter.text" prefix-icon="el-icon-search"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="products" v-loading="loading" class="orders-table tablewithshading">
            <el-table-column prop="no" :label="$t('common.number')" width="150"></el-table-column>
            <el-table-column prop="model" :label="$t('masters.type')"></el-table-column>
            <el-table-column prop="name" :label="$t('common.name')"></el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right"  :width="$isSuperAdmin ? 160 : 116 + 'px'">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editProduct(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button size="mini" type="danger" @click="deleteProduct(scope.row.id)" v-if="$isFullAdmin && $isSuperAdmin">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
        <create-update-product-dialog :productId="productToEdit" :visible="dialogVisible" @dialogClosed="editFinished" @save="appendProduct"></create-update-product-dialog>
    </div>
</template>

<script>
    import CreateUpdateProductDialog from './CreateUpdateProductDialog'
    import api from '../api'

    export default {
        name: 'product-list',
        components: {
            CreateUpdateProductDialog
        },
        data() {
            return {
                products: [],
                loading: true,
                dialogVisible: false,
                productToEdit: null,
                filter: {
                    text: undefined
                },
                currentPage: 1,
                total: 0
            }
        },
        created() {
            this.loadProducts();
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    this.loadProducts();
                }
            }
        },
        methods: {
            download() {
                api.download(this.filter);
            },
            loadProducts() {
                this.loading = true
                api.getProducts(this.currentPage, this.filter.text).then(response => {
                    this.loading = false
                    this.products = response.data.items
                    this.total = response.data.total
                })
            },
            appendProduct(event) {
                if (event.new) {
                    this.products.push(event.data);
                    this.total += 1;
                } else {
                    this.loadProducts();
                }
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadProducts();
            },
            editProduct(id) {
                this.productToEdit = id
                this.dialogVisible = true
            },
            editFinished() {
                this.productToEdit = null
                this.dialogVisible = false
            },
            deleteProduct(id) {
                this.$confirm(
                    this.$t('common.thisWillDeleteProductContinue'),
                    'Warning',
                    {
                        confirmButtonText: this.$t('common.OK'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: 'warning'
                    }
                ).then(() => {
                    api.deleteProduct(id).then(() => {
                        this.loadProducts();
                        this.$message({
                            type: 'success',
                            message: this.$t('common.deleteCompleted')
                        })
                    });
                }).catch(_ => {});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/products/components/ProductList.vue